import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState, previewState } from "./reducer";
import type { OptInFormV2 } from "./types";

export const localStateSelector = makeModuleStateSelector<OptInFormV2.AppState>(defaultState, previewState);
